import { api } from '../App';
import { toast } from 'sonner';

/**
 * Authenticated blob download that goes through the shared axios `api` client
 * (which attaches the JWT bearer token). Avoids window.open() on protected
 * endpoints, which drops Authorization headers.
 *
 * @param {string} path            API path (e.g. "/batches/abc/pdf") or absolute URL
 * @param {string} filename        Suggested download filename
 * @param {object} [options]
 * @param {object} [options.params] Optional axios query params
 */
export async function downloadAuthedBlob(path, filename, options = {}) {
  try {
    const res = await api.get(path, { responseType: 'blob', params: options.params });

    // If server returned JSON error but wrapped in a blob (rare — 200 blob but 4xx handled by interceptor)
    const contentType = res.headers?.['content-type'] || '';
    if (contentType.includes('application/json')) {
      const text = await res.data.text();
      let detail = 'Download failed';
      try { detail = JSON.parse(text).detail || detail; } catch (_) {}
      toast.error(detail);
      return false;
    }

    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (err) {
    // Try to surface backend detail from a blob error body
    let detail = err.response?.data?.detail;
    if (!detail && err.response?.data instanceof Blob) {
      try { detail = JSON.parse(await err.response.data.text()).detail; } catch (_) {}
    }
    toast.error(detail || 'Download failed');
    return false;
  }
}
